<template>
  <el-select
    v-model="valueBackup"
    :placeholder="placeholder"
    filterable
    remote
    clearable
    :size="size"
    :remote-method="handleRemote"
    :loading="isLoading"
    @change="handleChange"
  >
    <v-avatar-option
      :value="listBackup"
      :ratio="1"
      radius="5px"
      avatar-key="cover"
      name-key="title"
    />
  </el-select>
</template>

<script>
import { index } from '@/api/integral-activity';

export default {
  props: {
    value: [Number, String],
    list: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: 'medium',
    },
    placeholder: {
      type: String,
      default: '请输入活动名称进行搜索',
    },
  },
  data: () => ({
    valueBackup: '',
    listBackup: [],
    isLoading: false,
  }),
  watch: {
    value(value) {
      if (value !== this.valueBackup) this.valueBackup = +value || '';
    },
    valueBackup(valueBackup) {
      if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
    },
    list(list) {
      if (JSON.stringify(list) !== JSON.stringify(this.listBackup)) this.listBackup = list || [];
    },
  },
  methods: {
    handleChange(valueBackup) {
      if (!valueBackup) return;

      for (let i = 0; i  < this.listBackup.length; i++) {
        if (this.listBackup[i].id === valueBackup) return this.$emit('itemChange', this.listBackup[i]);
      }
    },
    async getList(keyword) {
      this.isLoading = true;
      const { isError, data } = await index({ keyword, is_disable_count: 1 });
      this.isLoading = false;
      if (!isError) this.listBackup = data;
    },
    handleRemote(keyword) {
      if (keyword) return this.getList(keyword);

      this.list = [];
    },
  },
  beforeMount() {
    this.valueBackup = +this.value || '';
    if (this.list.length) {
      return this.listBackup = this.list;
    }

    this.getList('');
  },
};
</script>
